import { _ as __assign } from './_tslib-ff3a08af.js';
import { jsx } from 'react/jsx-runtime';
import SvgIcon from '@material-ui/core/SvgIcon';
import { createElement } from 'react';

var _path, _path2;
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }return n;
  }, _extends.apply(null, arguments);
}
function SvgNoPhoto(props) {
  return (/*#__PURE__*/createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: 36,
      height: 36
    }, props), _path || (_path = /*#__PURE__*/createElement("path", {
      fill: "none",
      d: "M0 0h24v24H0z"
    })), _path2 || (_path2 = /*#__PURE__*/createElement("path", {
      d: "M10.94 8.12L7.48 4.66 9 3h6l1.83 2H20c1.1 0 2 .9 2 2v12c0 .05-.01.1-.02.16l-5.1-5.1c.08-.35.12-.7.12-1.06 0-2.76-2.24-5-5-5-.36 0-.71.04-1.06.12zm9.55 15.19L18.17 21H4c-1.1 0-2-.9-2-2V7c0-.59.27-1.12.68-1.49l-2-2L2.1 2.1l19.8 19.8-1.41 1.41zm-6-5.99l-1.5-1.5c-.32.1-.64.18-.99.18-1.66 0-3-1.34-3-3 0-.35.08-.67.19-.98l-1.5-1.5A4.74 4.74 0 007 13c0 2.76 2.24 5 5 5 .91 0 1.76-.25 2.49-.68z"
    })))
  );
}

var NoPhotoIcon = function (props) {
  return jsx(SvgIcon, __assign({}, props, { component: SvgNoPhoto, viewBox: '0 0 24 24' }));
};

export { NoPhotoIcon as N };
